function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useEffect, useRef } from "react";
import classnames from "classnames";
import { animated, useSpring } from "@react-spring/web";
import { useThrottleFn } from "ahooks";
var classPrefix = "tc-scroll-mask";
var ScrollMask = function ScrollMask(props) {
  var scrollTrackRef = props.scrollTrackRef;
  var maskRef = useRef(null);
  var _useSpring = useSpring(function () {
      return {
        leftMaskOpacity: 0,
        rightMaskOpacity: 0,
        config: {
          clamp: true
        }
      };
    }),
    _useSpring2 = _slicedToArray(_useSpring, 2),
    _useSpring2$ = _useSpring2[0],
    leftMaskOpacity = _useSpring2$.leftMaskOpacity,
    rightMaskOpacity = _useSpring2$.rightMaskOpacity,
    api = _useSpring2[1];
  var _useThrottleFn = useThrottleFn(function () {
      var immediate = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var mask = maskRef.current;
      if (!mask) return;
      var scrollEl = scrollTrackRef.current;
      if (!scrollEl) return;
      var scrollLeft = scrollEl.scrollLeft;
      var showLeftMask = scrollLeft > 0;
      var showRightMask = scrollLeft + scrollEl.offsetWidth < scrollEl.scrollWidth;
      api.start({
        leftMaskOpacity: showLeftMask ? 1 : 0,
        rightMaskOpacity: showRightMask ? 1 : 0,
        immediate: immediate
      });
    }, {
      wait: 100,
      trailing: true,
      leading: true
    }),
    updateMask = _useThrottleFn.run;
  useEffect(function () {
    updateMask(true);
  }, [updateMask]);
  useEffect(function () {
    var scrollEl = scrollTrackRef.current;
    if (!scrollEl) return;
    scrollEl.addEventListener("scroll", updateMask);
    return function () {
      return scrollEl.removeEventListener("scroll", updateMask);
    };
  }, [scrollTrackRef, updateMask]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(animated.div, {
    ref: maskRef,
    className: classnames(classPrefix, "".concat(classPrefix, "-left")),
    style: {
      opacity: leftMaskOpacity
    }
  }), /*#__PURE__*/React.createElement(animated.div, {
    className: classnames(classPrefix, "".concat(classPrefix, "-right")),
    style: {
      opacity: rightMaskOpacity
    }
  }));
};
ScrollMask.defaultProps = {};
export default ScrollMask;